module.exports = __webpack_public_path__ + "static/media/ps-consultants.df10eeba.png";